'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

export function NavLink({
  href,
  icon,
  children,
}: {
  readonly href: string;
  readonly icon: ReactNode;
  readonly children: ReactNode;
}) {
  const pathname = usePathname();
  const active = pathname === href || (href !== '/' && pathname?.startsWith(href));
  return (
    <Link className="nav-item" href={href} aria-current={active ? 'page' : undefined}>
      <span aria-hidden="true" style={{ display: 'inline-flex' }}>
        {icon}
      </span>
      {children}
    </Link>
  );
}
